/* eslint-disable class-methods-use-this */
import { toast } from 'ui';
import Cookies from 'universal-cookie';
import { ErrorContext, FetchParams, Middleware, RequestContext, ResponseContext } from './codegen';

class AddCsrfHeaderMiddleware implements Middleware {
  // eslint-disable-next-line class-methods-use-this
  async pre(context: RequestContext): Promise<void | FetchParams> {
    const cookies = new Cookies();

    context.init.headers = {
      ...context.init.headers,
      'X-CSRFToken': cookies.get('csrftoken'),
    };

    return context;
  }
}

class HandleErrorsMiddleware implements Middleware {
  async onError(context: ErrorContext): Promise<void | Response> {
    if (!context.response || context.response.status === 0) {
      toast.error(
        gettext(
          "We couldn't connect to Retino servers. We'll keep trying but there may be a problem with your connection.",
        ),
      );
    }
  }

  async post({ response }: ResponseContext) {
    if (response.type === 'error') {
      toast.error(
        gettext(
          "We couldn't connect to Retino servers. We'll keep trying but there may be a problem with your connection.",
        ),
      );
    } else if (response.status === 500) {
      toast.error(gettext('We were not able to process your request. Our developers have been informed.'));
    } else if (response.status >= 501) {
      toast.error(gettext('We were not able to process your request.'));
    }
  }
}

export default {
  AddCsrfHeaderMiddleware,
  HandleErrorsMiddleware,
};
